module.exports = __webpack_public_path__ + "img/concrete-hole-decal-22.ea3c1750.png";